import { render } from "./About.vue?vue&type=template&id=233d7238"
const script = {}

import "./About.vue?vue&type=style&index=0&id=233d7238&lang=css"
script.render = render

export default script